var map = {
	"./account-circle.svg": 5,
	"./arrow-left.svg": 6,
	"./arrow-right.svg": 7,
	"./caret-down.svg": 8,
	"./caret-left.svg": 9,
	"./caret-right.svg": 10,
	"./caret-up.svg": 11,
	"./facebook.svg": 12,
	"./instagram.svg": 13,
	"./logo-alt.svg": 14,
	"./logo.svg": 15,
	"./search.svg": 16,
	"./shopping-cart.svg": 17,
	"./times.svg": 18,
	"./twitter.svg": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4;